module.exports = __webpack_public_path__ + "img/s9-3.af9ec579.jpg";